import { render } from "./createSpacDialog.vue?vue&type=template&id=5129c4bf"
import script from "./createSpacDialog.vue?vue&type=script&lang=js"
export * from "./createSpacDialog.vue?vue&type=script&lang=js"

import "./createSpacDialog.vue?vue&type=style&index=0&id=5129c4bf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__